import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
import { IAuthContext } from 'models/common';
import { Login } from '../Login';
import { EllipseGreyBlackButton } from 'components/Common/Button';

interface IProps {
	context: IAuthContext;
	t?: (key: string) => string;
	register?: boolean;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class LoginRegisterComponent extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}
	public render() {
		const { isAuthenticated } = this.props.context;
		if (isAuthenticated()) {
			return null;
		}
		return (
			<div className="loginRegister">
				<EllipseGreyBlackButton className="login-button">
					<Login />
				</EllipseGreyBlackButton>
			</div>
		);
	}
}
const LoginRegister = withAuthContext(LoginRegisterComponent);

export { LoginRegister };
